<action-bar>
  <action-button [className]="'action-default'" [iconClass]="'fa fa-chevron-left'" (actionClick)="onClickBack()">Save and Back</action-button>
  <action-button [className]="'action-primary'" [iconClass]="'fa fa-star'" (actionClick)="onClickComplete()" [disabled]="disableComplete" [ngbTooltip]="(disableComplete) ? 'Required: Consultant Assigned and Report Attached or Verbal Complete.' : ''" container="body">Mark Assessment Complete</action-button>
</action-bar>

@if (attachments && attachments.length) {
  <div class="card">
    <h4 class="card-header">Existing Reports: {{assessmentRequest.candidate.displayName}}</h4>
    <div class="card-body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Assessment Type</th>
            <th>Report Type</th>
            <th>Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (attachment of attachments; track attachment) {
            <tr>
              <td>{{attachment.referenceName}}</td>
              <td>{{attachment.typeName}}</td>
              <td>
                <a (click)="AttachmentService.download(attachment.attachmentId)" class="NameLink">{{attachment.filename}}</a>
              </td>
              <td>
                <button type="button" class="btn btn-link" (click)="onClickDelete(attachment)"><span class="fa fa-remove"></span></button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

<div class="card">
  <h4 class="card-header">Add Report: {{assessmentRequest.candidate.displayName}}</h4>
  <div class="card-body">
    @if (assessmentLevelReferences && assessmentLevelReferences.length && !assessmentRequest.parentAssessmentRequestId) {
      <div class="row">
        <div class="col">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Assessment Level</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (assessmentLevelReference of assessmentLevelReferences; track trackByAssessmentLevelReferenceId($index, assessmentLevelReference)) {
                @if (isValidAssessmentLevel(assessmentLevelReference)) {
                  <tr>
                    <td>{{assessmentLevelReference.name}}</td>
                    <td>
                      <button type="button" class="btn btn-sm btn-primary" (click)="onClickUploadAssessmentLevel(assessmentLevelReference, $event)">
                        <span class="fa fa-cloud-upload"></span> Upload
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    @if (anyValidAdditionalService()) {
      <div class="row">
        <div class="col">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Additional Service</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (additionalServiceReference of additionalServiceReferences; track trackByAdditionalServiceReferenceId($index, additionalServiceReference)) {
                @if (isValidAdditionalService(additionalServiceReference)) {
                  <tr>
                    <td>{{additionalServiceReference.name}}</td>
                    <td>
                      @if (verbalFeedbackComplete(additionalServiceReference)) {
                        <span style="margin-right:12px;" class="text-success"><i class="fa fa-check"></i>Feed back delivered {{testingSchedule.feedbackDate ? (testingSchedule.feedbackDate | date: 'MM/dd/yyyy') : "Date Not Entered"}}</span>
                      }
                      @if (isVerbalFeedback(additionalServiceReference) && verbalFeedbackComplete(additionalServiceReference)) {
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="onClickVerbalFeedbackNotComplete(additionalServiceReference, $event)">
                          <span class="fa fa-undo"></span> Mark Feedback Not Delivered
                        </button>
                      }
                      @if (isVerbalFeedback(additionalServiceReference) && !verbalFeedbackComplete(additionalServiceReference)) {
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="onClickVerbalFeedbackComplete(additionalServiceReference, $event)">
                          <span class="fa fa-check"></span> Mark Feedback Delivered
                        </button>
                      }
                      @if (!isVerbalFeedback(additionalServiceReference)) {
                        <button type="button" class="btn btn-sm btn-primary"
                          (click)="onClickUploadAdditionalService(additionalServiceReference, $event)">
                          <span class="fa fa-cloud-upload"></span> Upload
                        </button>
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
</div>

